module.exports = "<header class=\"main-header\">\r\n  <!-- Header Navbar: style can be found in header.less -->\r\n  <nav class=\"navbar navbar-static-top justify-content-between\">\r\n    <div class=\"logo\">\r\n      <img src=\"assets/img/logo.png\" height=\"35\">\r\n    </div>\r\n    <span class=\"user-info\"><i class='fa fa-user'></i> {{authUser.firstName+ ' '+authUser.lastName}}</span>\r\n  </nav>\r\n</header>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Biziclick/bizisystem/src/app/main/header/header.component.html
// module id = ../../../../../src/app/main/header/header.component.html
// module chunks = main